module.exports = __webpack_public_path__ + "static/img/database.e1db6cef.svg";